import { render, staticRenderFns } from "./tableOwnDelegatedTasks.vue?vue&type=template&id=e1835c16&scoped=true"
import script from "./tableOwnDelegatedTasks.vue?vue&type=script&lang=js"
export * from "./tableOwnDelegatedTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1835c16",
  null
  
)

export default component.exports